import { Gauge } from 'lucide-react';
import { DiscardChangesDialog } from '@/components/common/DiscardChangesDialog';
import { FormDialog, FormSection, FormTextField } from '@/components/common/FormDialog';
import { useLimitTypeForm } from '../hooks/useLimitTypeForm';
import type { LimitType } from '../types/limitType.types';

interface LimitTypeFormModalProps {
  limitType: LimitType | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LimitTypeFormModal({ limitType, open, onOpenChange }: LimitTypeFormModalProps) {
  const {
    form,
    isPending,
    submit,
    isDiscardDialogOpen,
    requestClose,
    confirmDiscard,
    cancelDiscard,
  } = useLimitTypeForm({
    limitType,
    open,
    onClose: () => onOpenChange(false),
  });

  function handleOpenChange(nextOpen: boolean) {
    if (!nextOpen) {
      requestClose();
      return;
    }
    onOpenChange(nextOpen);
  }

  return (
    <>
      <FormDialog
        open={open}
        onOpenChange={handleOpenChange}
        icon={Gauge}
        title="Edit Limit"
        description={limitType ? `Set the range allowed for "${limitType.name}".` : ''}
        form={form}
        isPending={isPending}
        isEditMode
        onSubmit={submit}
      >
        <FormSection>
          <FormTextField
            control={form.control}
            name="lowValue"
            label="Low Value"
            placeholder="0"
            inputMode="decimal"
            hasTabularNumbers
          />
          <FormTextField
            control={form.control}
            name="highValue"
            label="High Value"
            placeholder="1000"
            inputMode="decimal"
            hasTabularNumbers
          />
        </FormSection>
      </FormDialog>

      <DiscardChangesDialog
        open={isDiscardDialogOpen}
        onOpenChange={(nextOpen) => !nextOpen && cancelDiscard()}
        onDiscard={confirmDiscard}
      />
    </>
  );
}
